module.exports = __webpack_public_path__ + "img/1.4ea9de1a.png";